import { render, staticRenderFns } from "./CaracteristicasVivienda.vue?vue&type=template&id=18bc43f8&scoped=true&"
import script from "./CaracteristicasVivienda.vue?vue&type=script&lang=js&"
export * from "./CaracteristicasVivienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc43f8",
  null
  
)

export default component.exports